import React, { useContext } from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router-dom'
import { useFeatureFlags } from '@node-space/hooks'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { PathNames } from 'constants/General'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { paymentAtom } from './atoms/atoms'

export const SendComplete = () => {
  const { t } = useTranslation()
  const { enableTravelRulePayins } = useFeatureFlags()
  const paymentUrl = enableTravelRulePayins
    ? `${PathNames.PAYMENTS}${PathNames.CRYPTO}`
    : `${PathNames.PAYMENTS}${PathNames.PAYMENTS_LINKS}`
  const match = useMatch(paymentUrl)
  const [walletAction] = useContext(WalletActionContext)
  const payment = useAtomValue(paymentAtom)
  const contact = useAtomValue(contactAtom)
  const navigate = useNavigate()

  const handleNavigateClick = async () => {
    if (match) {
      walletAction?.meta?.onPayoutSuccess()
      walletAction?.onClose()
    } else if (enableTravelRulePayins) {
      navigate(`${PathNames.PAYMENTS}${PathNames.CRYPTO}`)
    } else {
      navigate(`${PathNames.PAYMENTS}${PathNames.PAYMENTS_LINKS}`)
    }
  }

  return (
    <StatusCard
      testid="complete-success"
      headline={t('wallets.send.completeSuccess', {
        fromCurrencyAmounts: `${payment?.walletCurrency?.amount} ${payment?.walletCurrency?.currency}`,
        toCurrencyAmounts: `${payment?.paidCurrency?.amount} ${payment?.paidCurrency?.currency}`,
        contactName: contact?.name,
      })}
      borderless
      status="success"
      cardButton={{
        onClick: handleNavigateClick,
        name: t('wallets.send.goToPayments'),
        testid: 'transaction-history',
      }}
    />
  )
}
